/**
 * @name: index.js
 * @description: 布局类、业务类组件集中引入
 * @author: 温永江
 * @create: 2020/07/22 15:47:03
 * @update: 2020/07/22 15:47:03
 */
import Vue from 'vue';

Vue.component('YView', () => import(/* webpackChunkName: "chunks-layout" */ '@/components/YView'));
Vue.component('YQuery', () => import(/* webpackChunkName: "chunks-layout" */ '@/components/YQuery/YQuery'));

Vue.component('YQueryItem', () =>
  import(
    /* webpackChunkName: "chunks-layout" */
    '@/components/YQuery/YQueryItem'
  )
);

Vue.component('YTab', () => import(/* webpackChunkName: "chunks-layout" */ '@/components/YTab'));
Vue.component('YTabItem', () => import(/* webpackChunkName: "chunks-layout" */ '@/components/YTabItem'));
Vue.component('YForm', () => import(/* webpackChunkName: "chunks-layout" */ '@/components/YForm'));
Vue.component('YFormItem', () => import(/* webpackChunkName: "chunks-layout" */ '@/components/YFormItem'));
Vue.component('YPanel', () => import(/* webpackChunkName: "chunks-layout" */ '@/components/YPanel'));
Vue.component('YTag', () => import(/* webpackChunkName: "chunks-layout" */ '@/components/YTag'));
// 区域选择组件
Vue.component('YArea', () => import(/* webpackChunkName: "chunks-area" */ '@/components/YArea/YArea'));
// 空表格占位组件
Vue.component('YEmpty', () => import(/* webpackChunkName: "chunks-layout" */ '@/components/YEmpty'));
Vue.component('YPopupBody', () => import(/* webpackChunkName: "chunks-layout" */ '@/components/YPopupBody'));

Vue.component('YRotateIcon', () => import(/* webpackChunkName: "chunks-functions" */ '@/components/YRotateIcon'));

Vue.component('YButton', () => import(/* webpackChunkName: "chunks-functions" */ '@/components/YButton'));
Vue.component('YSelectArea', () => import(/* webpackChunkName: "chunks-functions" */ '@/components/YSelectArea'));
Vue.component('YUploadFile', () => import(/* webpackChunkName: "chunks-functions" */ '@/components/YUploadFile'));
Vue.component('YUploadFile2', () => import(/* webpackChunkName: "chunks-functions" */ '@/components/YUploadFile2'));
Vue.component('YImage', () => import(/* webpackChunkName: "chunks-functions" */ '@/components/YImage'));
Vue.component('YAnchor', () => import(/* webpackChunkName: "chunks-functions" */ '@/components/YAnchor'));
Vue.component('Ueditor', () => import(/* webpackChunkName: "chunks-functions" */ '@/components/Ueditor'));

Vue.component('YSupplier', () => import(/* webpackChunkName: "chunks-functions" */ '@/components/YSupplier'));
Vue.component('ToolTip', () => import(/* webpackChunkName: "chunks-functions" */ '@/components/ToolTip'));
Vue.component('YResetPassword', () => import(/* webpackChunkName: "chunks-functions" */ '@/components/YResetPassword'));
Vue.component('ToolTip', () => import(/* webpackChunkName: "chunks-functions" */ '@/components/ToolTip'));
Vue.component('Insensitive', () => import(/* webpackChunkName: "chunks-functions" */ '@/components/Insensitive.vue'));

// 以下是旧文件 供参考

// import Vue from "vue";

// //布局
// Vue.component("YEmpty", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YEmpty")
// );
// Vue.component("YView", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YView")
// );

// Vue.component("YGrid", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YGrid/YGrid")
// );

// Vue.component("YGridRow", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YGrid/YGridRow")
// );

// Vue.component("YGridCell", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YGrid/YGridCell")
// );

// Vue.component("YQuery", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YQuery/YQuery")
// );

// Vue.component("YQueryItem", () =>
//   import(
//     /* webpackChunkName: "y-c-layout" */
//     "@/components/YQuery/YQueryItem"
//   )
// );
// Vue.component("YPopupBody", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YPopupBody")
// );

// Vue.component("YAction", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YAction/YAction")
// );
// Vue.component("YActionItem", () =>
//   import(
//     /* webpackChunkName: "y-c-layout" */
//     "@/components/YAction/YActionItem"
//   )
// );
// Vue.component("YTab", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YTab")
// );
// Vue.component("YTabItem", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YTabItem")
// );
// Vue.component("YForm", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YForm")
// );
// Vue.component("YFormItem", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YFormItem")
// );
// Vue.component("YInsert", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YAction/YInsert")
// );
// Vue.component("YEnable", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YAction/YEnable")
// );
// Vue.component("YDelete", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YAction/YDelete")
// );
// Vue.component("YComplete", () =>
//   import(
//     /* webpackChunkName: "y-c-layout" */
//     "@/components/YAction/YComplete"
//   )
// );
// Vue.component("YPrint", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YAction/YPrint")
// );
// Vue.component("YSave", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YAction/YSave")
// );
// Vue.component("YDraft", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YAction/YDraft")
// );

// Vue.component("YBillTitle", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YBillTitle")
// );
// Vue.component("YBillFlow", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YBillFlow")
// );
// Vue.component("YStatus", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/status/YStatus")
// );
// Vue.component("YState", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/status/YState")
// );
// Vue.component("YBillStatus", () =>
//   import(
//     /* webpackChunkName: "y-c-layout" */
//     "@/components/status/YBillStatus"
//   )
// );
// Vue.component("YBillCode", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YBillCode")
// );
// Vue.component("YExport", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YAction/YExport")
// );
// Vue.component("YImport", () =>
//   import( /* webpackChunkName: "y-c-functions" */ "@/components/YAction/YImport")
// );
// Vue.component("YRefresh", () =>
//   import( /* webpackChunkName: "y-c-layout" */ "@/components/YRefresh")
// );

// //基础数据类
// Vue.component("YSite", () =>
//   import( /* webpackChunkName: "y-c-data" */ "@/components/YSite")
// );
// Vue.component("YPackage", () =>
//   import( /* webpackChunkName: "y-c-data" */ "@/components/YPackage")
// );
// Vue.component("YFetch", () =>
//   import( /* webpackChunkName: "y-c-data" */ "@/components/render-less/YFetch"))
// Vue.component("YHandler", () =>
//   import( /* webpackChunkName: "y-c-data" */ "@/components/YHandler")
// );
// Vue.component("YSaleman", () =>
//   import( /* webpackChunkName: "y-c-data" */ "@/components/YSaleman")
// );
// Vue.component("YStore", () =>
//   import( /* webpackChunkName: "y-c-data" */ "@/components/YStore")
// );
// Vue.component("YBalance", () =>
//   import( /* webpackChunkName: "y-c-data" */ "@/components/YBalance")
// );
// Vue.component("YBranch", () =>
//   import( /* webpackChunkName: "y-c-data" */ "@/components/YBranch")
// );
// Vue.component("YUserBranch", () =>
//   import( /* webpackChunkName: "y-c-data" */ "@/components/YUserBranch")
// );
// Vue.component("YBillPro", () =>
//   import( /* webpackChunkName: "y-c-data" */ "@/components/YBillPro")
// );
// Vue.component("YPaymentCategary", () =>
//   import( /* webpackChunkName: "y-c-data" */ "@/components/YPaymentCategary")
// );
// //功能性组件
// Vue.component("YRotateIcon", () =>
//   import( /* webpackChunkName: "y-c-functions" */ "@/components/YRotateIcon")
// );
// Vue.component("YProList", () =>
//   import( /* webpackChunkName: "y-c-functions" */ "@/components/YProList")
// );
// Vue.component("YBalanceList", () =>
//   import( /* webpackChunkName: "y-c-functions" */ "@/components/YBalanceList")
// );
// Vue.component("YColumnAction", () =>
//   import( /* webpackChunkName: "y-c-functions" */ "@/components/YColumnAction")
// );
// Vue.component("YInputImei", () =>
//   import(
//     /* webpackChunkName: "y-c-functions" */
//     "@/components/YInputImei/YInputImei"
//   )
// );
// Vue.component("YInputImeiOut", () =>
//   import(
//     /* webpackChunkName: "y-c-functions" */
//     "@/components/YInputImei/YInputImeiOut"
//   )
// );

// Vue.component("YTemplateDownload", () =>
//   import(
//     /* webpackChunkName: "y-c-functions" */
//     "@/components/YAction/YTemplateDownload"
//   )
// );
// Vue.component("YNumberRange", () =>
//   import(
//     /* webpackChunkName: "y-c-functions" */
//     "@/components/YNumberRange"
//   )
// );
// //区域选择 y-c-area
// Vue.component("YArea", () =>
//   import( /* webpackChunkName: "y-c-area" */ "@/components/YArea/YArea")
// );

// //展示类
// Vue.component("YSourceBillDetails", () =>
//   import(
//     /* webpackChunkName: "y-c-display" */
//     "@/components/YSourceBillDetails"
//   )
// );
// Vue.component("YNumber", () =>
//   import(
//     /* webpackChunkName: "y-c-display" */
//     "@/components/YNumber"
//   )
// );
// Vue.component("YDeleteButton", () =>
//   import(
//     /* webpackChunkName: "y-c-display" */
//     "@/components/YDeleteButton"
//   ))
// Vue.component("YPopupProSelect", () =>
//   import(
//     /* webpackChunkName: "y-c-trees" */
//     "@/components/trees/product/YPopupProSelect"
//   )
// );
// Vue.component("YAutoCompleteProduct", () =>
//   import(
//     /* webpackChunkName: "y-c-trees" */
//     "@/components/trees/product/YAutoCompleteProduct"
//   )
// );

// Vue.component("YSupplier", () =>
//   import( /* webpackChunkName: "y-c-trees" */ "@/components/trees/supplier/YSupplier")
// );
// Vue.component("YCustomer", () =>
//   import( /* webpackChunkName: "y-c-trees" */ "@/components/trees/customer/YCustomer")
// );
// Vue.component("YCustomerTree", () =>
//   import(
//     /* webpackChunkName: "y-c-trees" */
//     "@/components/trees/customer/YCustomerTree"
//   )
// );
// Vue.component("YCustomerSelectTree", () =>
//   import(
//     /* webpackChunkName: "y-c-trees" */
//     "@/components/trees/customer/YCustomerSelectTree"
//   )
// );
// Vue.component("YSupplierTree", () =>
//   import(
//     /* webpackChunkName: "y-c-trees" */
//     "@/components/trees/supplier/YSupplierTree"
//   )
// );
// Vue.component("YSupplierSelectTree", () =>
//   import(
//     /* webpackChunkName: "y-c-trees" */
//     "@/components/trees/supplier/YSupplierSelectTree"
//   )
// );
// Vue.component("YProductCategoryTree", () =>
//   import(
//     /* webpackChunkName: "y-c-trees" */
//     "@/components/trees/product/YProductCategoryTree"
//   )
// );
// Vue.component("YProductCategorySelectTree", () =>
//   import(
//     /* webpackChunkName: "y-c-trees" */
//     "@/components/trees/product/YProductCategorySelectTree"
//   )
// );
